import { LogLevel, OpenIdConfiguration } from 'angular-auth-oidc-client';
import { environment } from 'environments/environment';

export const ConfigOidcProvider: OpenIdConfiguration = {
  configId: 'sessionOIDC',
  clientId: environment.sso.client_id,
  authority: environment.sso.authority,
  redirectUrl: environment.sso.redirect_uri,
  postLogoutRedirectUri: environment.sso.post_logout_redirect_uri,
  scope: environment.sso.scope,
  responseType: environment.sso.response_type,
  historyCleanupOff: true,
  triggerAuthorizationResultEvent: true,
  autoCleanStateAfterAuthentication: true,
  silentRenew: false,
  useRefreshToken: false,
  disableIdTokenValidation: false,
  disableIatOffsetValidation: true,
  disableRefreshIdTokenAuthTimeValidation: true,
  ignoreNonceAfterRefresh: false,
  disablePkce: false,
  autoUserInfo: false,
  logLevel: LogLevel.Debug,
  customParamsAuthRequest: {
    ui_locales: 'es'
  },
  startCheckSession: false,
  renewUserInfoAfterTokenRenew: false
};
